import CustomerView from 'models/location/customer_view';
import requestCustomerExtension from './request_customer_extension';

export default class RefreshExternalCustomerData {
  constructor(context) {
    this.context = context;
  }

  run() {
    const currentLocation = this.context.stores.currentLocation.get();
    if (!(currentLocation instanceof CustomerView)) {
      return;
    }

    requestCustomerExtension(this.context, currentLocation.customerId);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/external_customer_lookup/refresh_external_customer_data.js